import { ref } from 'vue';

const isVisible = ref(false);

export function useVersionModal() {
  const openModal = () => {
    isVisible.value = true;
  };
  
  const closeModal = () => {
    isVisible.value = false;
  };

  return {
    isVisible,
    openModal,
    closeModal
  };
}
